export default {
    data: [
        'Mỹ Phước',
        'Mỹ Hòa',
        'Mỹ Quý',
        'Mỹ Xuyên',
        'Đông Xuyên',
        'Mỹ Bình',
        'Mỹ Long',
        'Bình Khánh',
        'Bình Đức',
        'Mỹ Thới',
        'Mỹ Thạnh',
        'Mỹ Khánh',
        'Mỹ Hòa Hưng',
        'Thoại Sơn',
        'Châu Thành',
        'Ngoài LX',
        'Tri Tôn', 
        'Chợ Mới', 
        'Thốt Nốt', 
        'TPHCM',
        'Rạch Giá',
        'Long Xuyên'
    ]
}